import { List, Record } from "immutable";

import { ModuleStudiedEvent } from "seneca-common/features/stats/state";

import SessionFinishedEvent from "./SessionFinishedEvent";

export type SessionReportType = {
  platform: string | null;
  clientVersion: string | null;
  session: SessionFinishedEvent | null;
  modules: List<ModuleStudiedEvent>;
};

const defaultSessionReport: SessionReportType = {
  platform: null,
  clientVersion: null,
  session: null,
  modules: List()
};

export default class SessionReport extends Record(defaultSessionReport) {}
